import { useWindowSize } from "@/utils/hooksUtils";
import { cssVariables, numberOrZero } from "@/utils/utils";
import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import Ellipsis from "../../../../../../common/components/views/Ellipsis";
import { DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH, percentageChange } from "../../../../utils";
import styles from "../../statistics/DashboardStatisticsWidget.module.scss";
import { StatDivider } from "./common/StatDivider";
import { StatNumber } from "./common/StatNumber";
import { TrendIndicator } from "./common/TrendIndicator";
import { STATS_HEIGHT } from "./common/utils";

type Props = {
  data: {
    brokersCount?: number;
    tippersCount?: number;
    previousTippersCount?: number;
    previousBrokersCount?: number;
  };
};

export const AgentsData = ({ data }: Props) => {
  const { t } = useTranslation();

  const windowSize = useWindowSize();

  const statChange = percentageChange(
    numberOrZero(data.brokersCount) + numberOrZero(data.tippersCount),
    numberOrZero(data.previousBrokersCount) + numberOrZero(data.previousTippersCount),
  );

  return (
    <>
      <Flex align="center">
        <Button className={styles.labelIcon} variant="filled" color="magenta" icon={<AntIcon type="user-switch" />} />

        <Flex style={{ minWidth: 0 }} align="center">
          <Ellipsis>
            <span
              className="margin-left-tiny margin-right-tiny"
              style={{ fontSize: windowSize.innerWidth > DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH ? 21 : 18 }}
            >
              {t("dashboard.statistics.agentsCount")}
            </span>
          </Ellipsis>

          <TrendIndicator value={statChange} />
        </Flex>
      </Flex>

      <Flex className="margin-top-tiny" style={{ height: STATS_HEIGHT }}>
        {data.brokersCount ? (
          <div style={{ textAlign: data.tippersCount ? "right" : "center", flex: 1 }}>
            <div style={{ color: cssVariables.colorGrey }}>{t("dashboard.statisticsExtended.brokers")}</div>

            <StatNumber value={data.brokersCount} />
          </div>
        ) : undefined}

        {data.brokersCount && data.tippersCount ? <StatDivider /> : undefined}

        {data.tippersCount ? (
          <div style={{ flex: 1, textAlign: data.brokersCount ? undefined : "center" }}>
            <div style={{ color: cssVariables.colorGrey }}>{t("dashboard.statisticsExtended.tippers")}</div>

            <StatNumber value={data.tippersCount} />
          </div>
        ) : undefined}
      </Flex>
    </>
  );
};
